import styled from "@emotion/styled"
import { PText } from "@porsche-design-system/components-react"
import type { PTextProps } from "@porsche-design-system/components-react"
import type { PropsWithChildren } from "react"

export const DisabledItem = styled(({ children, ...rest }: PropsWithChildren<PTextProps>) => (
	<PText color="contrast-medium" {...rest}>
		{children}
	</PText>
))`
	&:hover {
		cursor: not-allowed;
	}
`
